import * as services from './sourceAccounts.queries';

export default services;
